import { css } from 'styled-components'

const sizes = {
  desktop: 1366,
  desktopNarrow: 1280,
  tabletWide: 1024,
  tabletNarrow: 768,
  phoneWide: 668,
  phone: 320
};

// iterate through the sizes and create a media template
const media = Object.assign(Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)}
    }
  `

  accumulator['not' + label[0].toUpperCase() + label.slice(1)] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)}
    }
  `  
  return accumulator
}, {}), {
  maxWidth: (pxValue) => (...args) => css`
    @media (max-width: ${pxValue/16}em) {
      ${css(...args)}
    }
  `,
  minWidth: (pxValue) => (...args) => css`
    @media (min-width: ${pxValue/16}em) {
      ${css(...args)}
    }
  `,
  minHeight: (pxValue) => (...args) => css`
    @media (min-height: ${pxValue / 16}em) {
      ${css(...args)}
    }
  `,
  maxHeight: (pxValue) => (...args) => css`
    @media (max-height: ${pxValue / 16}em) {
      ${css(...args)}
    }
  `,
});

export {
  media,
  sizes,
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/utils.js